


export type WorkspaceFileSourceType = 'DirectUpload' | 'Chat' | 'FormInstance' | 'Abacus';

export const WorkspaceFileSourceType = {
    DirectUpload: 'DirectUpload' as WorkspaceFileSourceType,
    Chat: 'Chat' as WorkspaceFileSourceType,
    FormInstance: 'FormInstance' as WorkspaceFileSourceType,
    Abacus: 'Abacus' as WorkspaceFileSourceType
};

